/* eslint-disable */
import "react-multi-carousel/lib/styles.css";

import moment from "moment";
import queryString from "query-string";
import ManageAccountTabs from "./Tabs";
import { FlagIcon } from "react-flag-kit";
import Carousel from "react-multi-carousel";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { FaArrowLeft, FaPlus } from "react-icons/fa6";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import {
  getPlan,
  postCancelPlan,
  getStudentPlans,
  getAffiliateInfo,
  getAdminUserInfo,
  getUserInformation,
  getSubscriptionStatus,
  postExtraClassStudent,
  postStudentPlansRenovate,
  subscriptionsStripeGetPlans,
  updateMultipleStudentPlanLanguage,
} from "../../store/middleware";
import DowngradeUpgrade from "./DowngradeUpgrade";
import CardPlans from "../../components/CardPlans";
import Header from "../../components/Header/NewHeader";
import ButtonMB from "../../components/Buttons/Button";
import LineCard from "../../components/LineCard/LineCard";
import SideMenu from "../../components/SideMenu/SideMenu";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import { setBuyPlans } from "../../store/slices/generics.slice";
import cancelImg from "../../assets/images/img-cancel-plan.png";
import { SCButtonAddInput } from "../../components/Buttons/styles";
import flagMultilingoPNG from "../../assets/images/flag_multilingo.png";
import Myaccount from "../../assets/images/icons/icon_myaccount_header.svg";
import IconPricing from "../../assets/images/sign-up/icon_pricing_world_blue.svg";
import ChangeCardComponent from "../../components/StripeCheckoutComponent/ChangeCard";

import { PlansAccountStyles, Billing } from "./Styles";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1370 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1370, min: 800 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 800, min: 0 },
    items: 1,
  },
};

function PlansAccount() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { buyPlans } = useSelector((state) => state.genericReducer);

  const [cpn, setCpn] = useState("");
  const [plans, setPlans] = useState([]);
  const [alertTitle, setAlertTitle] = useState("");
  const [changeType, setChangeType] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [openPlans, setOpenPlans] = useState(false);
  const [historyPlan, setHistoryPlan] = useState([]);
  const [cancelPlan, setCancelPlan] = useState(null);
  const [renovatePlan, setRenovatePlan] = useState(0);
  const [successMsg, setSuccessMsg] = useState(false);
  const [studentPlans, setStudentPlans] = useState([]);
  const [paypalStatus, setPaypalStatus] = useState("");
  const [responseError, setResponseError] = useState("");
  const [showPlanInfo, setShowPlanInfo] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState(0);
  const [successChange, setSuccessChange] = useState(false);
  const [showManagePlan, setShowManagePlan] = useState(false);
  const [selectedPlanName, setSelectedPlanName] = useState("");
  const [alertDescription, setAlertDescription] = useState("");
  const [openAlertCancel, setOpenAlertCancel] = useState(false);
  const [openalertRenovate, setOpenalertRenovate] = useState(false);
  const [extraClassConfirm, setExtraClassConfirm] = useState(false);
  const [btnCanceledDisable, setBtnCanceledDisable] = useState(false);
  const [studentPlanSelected, setStudentPlanSelected] = useState(null);
  const [reasonForcancellation, setReasonForcancellation] = useState("");
  const [openChangeCreditCard, setOpenChangeCreditCard] = useState(false);
  const [showPaymentHistories, setShowPaymentHistories] = useState(false);

  const showDialogError = (e) => {
    const { message = t("ERROR") } = e.message;

    setOpenAlert(true);
    setAlertTitle(t("ERROR"));
    setAlertDescription(message);
  };

  const handleRenderPlans = () => {
    let plansCancel = [];

    studentPlans?.length &&
      studentPlans?.map(
        (plan) =>
          plan?.studentPlanPayments?.filter((planPayment) => planPayment.providerState === "Active")[0] &&
          plansCancel.push(
            plan?.studentPlanPayments?.filter((planPayment) => planPayment.providerState === "Active")[0],
          ),
      );

    return plansCancel?.length > 0 ? false : true;
  };

  const loadPlans = async (cpn) => {
    const { country_code } = await dispatch(getUserInformation());
    const countryURL = country_code === "BR" ? "BR" : "US";
    const isAffiliate = await dispatch(getAffiliateInfo(user?.id));
    const affiliateId = studentPlans[0]?.studentPlanPayments[0]?.affiliateId;

    const exclusiveFor = isAffiliate
      ? "affiliate"
      : studentPlans || studentPlans[0]?.studentPlanPayments
      ? "partner"
      : affiliateId !== null
      ? "affiliate"
      : "website_stripe";

    if (handleRenderPlans()) {
      const response = await dispatch(subscriptionsStripeGetPlans("", "", countryURL, exclusiveFor, true, null, cpn));

      const newPlans = response.map((plan) => {
        return { ...plan, totalClasses: plan.unlimited ? 9999 : plan.totalClasses, currency: countryURL };
      });

      dispatch(setBuyPlans(newPlans));

      setPlans(newPlans);
      setOpenPlans(true);
    } else {
      const response = await dispatch(subscriptionsStripeGetPlans("", "", countryURL, exclusiveFor, true, null, cpn));

      const newPlans = response.map((plan) => {
        return { ...plan, totalClasses: plan.unlimited ? 9999 : plan.totalClasses, currency: countryURL };
      });

      dispatch(setBuyPlans(newPlans));

      setPlans(newPlans);
      setOpenPlans(true);
    }
  };

  const loadInfos = async () => {
    let paypalType = queryString.parse(window?.location?.search).type;
    let paypalToken = queryString.parse(window?.location?.search).token;
    let paypalStatus = queryString.parse(window?.location?.search).status;
    let paypalPayertId = queryString.parse(window?.location?.search).PayerID;
    let openPlansURL = queryString.parse(window?.location?.search).openPlans;
    let paypalPaymentId = queryString.parse(window?.location?.search).paymentId;
    let state = location.state;

    await callApi(true);

    const responseUserInfo = await dispatch(getAdminUserInfo(`studentManagement/getbyuser/${user?.id}`));
    setCpn(decryptIfEncrypted(responseUserInfo.result.items[0]?.cpnCode ?? ""));

    if (state === "checkout") {
      setChangeType("checkout");
    }

    if (openPlansURL === "true" && studentPlans?.length === 0) {
      setChangeType("checkout");
      await loadPlans(decryptIfEncrypted(responseUserInfo.result.items[0]?.cpnCode)).then(() => setOpenPlans(true));
    }

    if (studentPlans?.length === 0 && openPlansURL !== "true") {
      setChangeType("checkout");
      setOpenPlans(false);
    }

    if (studentPlans?.length > 0 && openPlansURL === "true") {
      setChangeType("checkout");
      setOpenPlans(true);
    }

    if (studentPlans?.length > 0 && openPlansURL !== "true") {
      setChangeType("checkout");
      setOpenPlans(false);
      dispatch(setBuyPlans([]));
    }

    if (paypalType === "extraclass" && paypalPaymentId && paypalPayertId && user?.role == "student") {
      setExtraClassConfirm(true);
      dispatch(postExtraClassStudent({ providerId: paypalPaymentId, payerId: paypalPayertId }));
    }

    if (paypalType === "extraclass" && paypalToken && user?.role == "student") {
      setExtraClassConfirm(true);
      setPaypalStatus(paypalStatus);
    }

    if (
      paypalType !== "extraclass" &&
      paypalStatus !== undefined &&
      paypalToken !== undefined &&
      user?.role == "student"
    ) {
      setPaypalStatus(paypalStatus);
      dispatch(getSubscriptionStatus(paypalStatus, paypalToken));
    }
  };

  const callApi = () => {
    dispatch(getPlan(user.id))
      .then((res) => {
        let userPlans = res;
        userPlans?.map((item) => {
          const { availableClasses } = item;
          item.plan.totalClasses = item.plan.unlimited ? 300 : item.plan.totalClasses;
          item.cyclePercentage = 100 - (availableClasses / item.plan.totalClasses) * 100;
          item.edit = false;
          let levels = item.student.studentLevelGrades;
          item.studentPlanLanguages?.map((studentPlanLang) => {
            let level = levels.filter((level) => level.lingoLanguageId == studentPlanLang.lingoLanguageId);
            if (level?.length > 0) {
              studentPlanLang.level = level[0].level.level;
            }
          });
        });

        setStudentPlans(userPlans);
        setShowPaymentHistories(false);
      })
      .catch((err) => showDialogError(err));
  };

  const textCancelClass = (studentPlan, t, dateCancel = "") => {
    const cancels =
      studentPlan.studentPlanPayments &&
      studentPlan.studentPlanPayments?.find((item) => {
        return item.providerState === "Cancelled";
      });
    const hasCancelDate =
      studentPlan.studentPlanPayments &&
      studentPlan.studentPlanPayments?.find((item) => {
        return item.providerCancelDate !== null && item.providerCancelDate !== undefined;
      });
    return hasCancelDate && !cancels ? (
      <div className="stock">
        <p style={{ color: "#FF5666", fontWeight: "200", fontSize: 14 }}>
          {t("YOUR_PLAN")} <span style={{ color: "#FF5666", fontWeight: "bold" }}>{t("CANCELED_CYCLE")}</span>{" "}
          {dateCancel === "" ? t("RESET_CYCLE") : moment(dateCancel).format(t("DATE_FORMAT"))}
        </p>
      </div>
    ) : (
      <></>
    );
  };

  const submitRenovatePlan = () => {
    const studentPlanId = renovatePlan.studentPlanPayments[0].studentPlanId;

    dispatch(postStudentPlansRenovate(studentPlanId))
      .then(() => {
        closeAlertRenovate();
        setShowManagePlan(false);
        setShowPaymentHistories(true);
        setShowPlanInfo(false);
        loadInfos();
      })
      .catch((err) => {
        if (err.status > 201) {
          let msg = err.data.error.message;
          msg = msg.replace(/\[/g, "").replace(/]/g, "");
          const message = msg.split("message:");

          setResponseError(message[1] !== undefined ? message[1] : err.data.error.message);
        } else if (Array.isArray(err.data.error)) {
          setResponseError(err.data.error[0].message);
        } else {
          setResponseError("Make sure all fields are filled in");
        }
      });
  };

  const tooglePaymentHistory = (e, studentPlan, planId, show) => {
    e.preventDefault();

    const cancels = studentPlan?.studentPlanPayments?.find((item) => {
      return item.providerState === "Cancelled";
    });

    const hasCancelDate = studentPlan?.studentPlanPayments?.find((item) => {
      return item.providerCancelDate !== null && item.providerCancelDate !== undefined;
    });
    if (show && planId) {
      setStudentPlanSelected({ studentPlan, cancels: cancels ?? null, hasCancelDate });
      getPaymentHistory(studentPlan.id, planId);
    } else {
      setShowManagePlan(false);
      setShowPaymentHistories(true);
    }
  };

  const getPaymentHistory = (studentPlanId) => {
    dispatch(getStudentPlans(studentPlanId))
      .then((res) => {
        setHistoryPlan(res?.length > 0 ? res : []);
        setSelectedPlanName(studentPlans.filter((plan) => plan.id == studentPlanId)[0].plan.nameEnglish);
        setShowManagePlan(true);
        setShowPaymentHistories(true);

        window.scrollTo(0, 0);
      })
      .catch((err) => {
        showDialogError(err);
        setHistoryPlan();
      });
  };

  const handleSubmit = (e, submit) => {
    e.preventDefault();
    if (submit) {
      let changedPlanLanguage = [];
      let studentId = this.state.userPlans[0].studentId;
      studentPlans?.map(function (plan) {
        plan.studentPlanLanguages
          .filter((lang) => lang.edited === true)
          .map(function (planLang) {
            changedPlanLanguage.push({
              id: planLang.id,
              studentPlanId: planLang.studentPlanId,
              studentId: studentId,
              lingoLanguageId: planLang.lingoLanguageId,
              focus: planLang.focus,
              struct: planLang.struct,
              randomFixedTeachers: planLang.randomFixedTeachers,
            });
          });
      });

      if (changedPlanLanguage?.length > 0) {
        dispatch(updateMultipleStudentPlanLanguage(changedPlanLanguage))
          .then(() => callApi(true))
          .catch((err) => showDialogError(err));
      } else {
        callApi(true);
      }
    } else {
      callApi(true);
    }
  };

  const handleCancelPlan = (v) => {
    setOpenAlertCancel(true);
    setCancelPlan(v);
  };

  const handleChangeCreditCard = async () => {
    setOpenChangeCreditCard(true);
  };

  const handleRenovatePlan = (v) => {
    setOpenalertRenovate(true);
    setRenovatePlan(v);
  };

  const closeAlertRenovate = () => {
    setOpenalertRenovate(false);
  };

  const closeChangeCreditCard = () => {
    setOpenChangeCreditCard(false);
    window.location.href = "/manage-account/plan";
  };

  const handleChangeModal = ({ target: { name, value } }) => {
    switch (name) {
      case "reasonForcancellation":
        setReasonForcancellation(value);
        break;
      default:
        break;
    }
  };

  const closeAlert = () => {
    setOpenAlertCancel(false);
  };

  const handlerError = (v) => {
    setResponseError(v);
  };

  const submitCancel = () => {
    if (btnCanceledDisable) return;
    setOpenAlertCancel(false);
    setBtnCanceledDisable(true);
    const studentPlanId = cancelPlan.studentPlanPayments[0].studentPlanId;
    const provider = cancelPlan.studentPlanPayments[0].provider;

    const sendObj = {
      cancelNotes: reasonForcancellation,
    };

    dispatch(postCancelPlan(studentPlanId, sendObj, provider))
      .then((res) => {
        if (res) {
          setOpenAlertCancel(true);
          setBtnCanceledDisable(false);
          setSuccessMsg(t("SUCESS_CANCEL_PLAN"));
          setShowManagePlan(false);
          setShowPaymentHistories(true);
          setShowPlanInfo(false);
          loadInfos();
        }
      })
      .catch((err) => {
        if (err) {
          let msg = err.data.error || err.data.error.message;
          msg = msg.replace(/\[/g, "").replace(/]/g, "");
          const message = msg.split("message:");
          handlerError(message[1] !== undefined ? message[1] : msg);
        } else if (Array.isArray(err.data.error)) {
          handlerError(err.data.error[0].message);
        } else {
          handlerError("Make sure all fields are filled in");
        }

        setBtnCanceledDisable(false);
      });
  };

  useEffect(() => {
    loadInfos();
    return () => setStudentPlanSelected(null);
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header
          t={t}
          typeIcon="custom"
          title={t("MANAGE_ACCOUNT_TITLE")}
          icon={<img src={Myaccount} alt={t("MANAGE_ACCOUNT_TITLE")} />}
        />

        <PlansAccountStyles>
          <div className="tabs">
            <ManageAccountTabs />

            {buyPlans?.length === 0 && (
              <>
                {!showManagePlan && !openPlans && (
                  <div>
                    <div className="planBox">
                      {studentPlans?.map((studentPlan, planIndex) => {
                        const cancels = studentPlan.studentPlanPayments.find((item) => {
                          return item.providerState === "Cancelled";
                        });

                        const hasCancelDate =
                          studentPlan.studentPlanPayments &&
                          studentPlan.studentPlanPayments?.find((item) => {
                            return item.providerCancelDate !== null && item.providerCancelDate !== undefined;
                          });

                        const cyclePercentage =
                          parseFloat((studentPlan.availableClasses / studentPlan.plan.totalClasses) * 100) % 1 !== 0
                            ? parseFloat(
                                100 - (studentPlan.availableClasses / studentPlan.plan.totalClasses) * 100,
                              ).toFixed(2)
                            : parseFloat(100 - (studentPlan.availableClasses / studentPlan.plan.totalClasses) * 100);

                        const arrToSort = studentPlan?.studentPlanLanguages && [...studentPlan.studentPlanLanguages];

                        return (
                          <Fragment key={"plan" + planIndex}>
                            <div className="box">
                              <div className="PlansBox">
                                <div className="plans">
                                  <img src={IconPricing} alt="" width="40" height="40" />
                                  <div className="changePlan">
                                    <h2>{studentPlan.plan.nameEnglish}</h2>
                                  </div>
                                </div>

                                {/* {Planos cancelados} */}
                                {!cancels ? (
                                  <div className="plans">
                                    <div className="controlPlan">
                                      <div className="infos">
                                        <h2>{t("SCHEDULING_CONTROL").toUpperCase()}</h2>
                                        {studentPlan.studentPlanPayments &&
                                          studentPlan.studentPlanPayments?.length > 0 &&
                                          studentPlan.studentPlanPayments[0]?.providerNextCycleDate && (
                                            <h3>
                                              {t("RESETS_ON")}{" "}
                                              {moment(studentPlan.studentPlanPayments[0]?.providerNextCycleDate).format(
                                                t("DATE_FORMAT"),
                                              )}
                                            </h3>
                                          )}
                                      </div>
                                      {studentPlan.plan.unlimited && (
                                        <div className="numbers">
                                          <span>
                                            <img
                                              alt="multilingo"
                                              src={flagMultilingoPNG}
                                              style={{ width: "24px", marginTop: "6px" }}
                                            />
                                          </span>
                                          <span style={{ color: "#00D36A" }}>Unlimited</span>
                                        </div>
                                      )}
                                      {!studentPlan.plan.unlimited && (
                                        <div className="numbers">
                                          <span>{cyclePercentage} %</span>
                                          <span>
                                            {studentPlan.plan.totalClasses - studentPlan.availableClasses}/
                                            {studentPlan.plan.totalClasses} {t("CLASSES")}
                                          </span>
                                        </div>
                                      )}
                                    </div>

                                    {studentPlan.plan.unlimited && (
                                      <div className="stock">
                                        <hr style={{ backgroundColor: "#00D36A" }} />
                                      </div>
                                    )}
                                    {!studentPlan.plan.unlimited && (
                                      <div className="stock">
                                        <hr style={{ width: cyclePercentage + "%" }} />
                                      </div>
                                    )}
                                    {studentPlan.availablePartClasses > 0 && (
                                      <div className="stock">
                                        <div>
                                          <span>
                                            <b>{studentPlan.availablePartClasses}</b> <b>{t("EXTRA_CLASSES")}</b>{" "}
                                            {t("IN_STOCK")}.
                                          </span>
                                        </div>
                                      </div>
                                    )}

                                    {textCancelClass(
                                      studentPlan,
                                      t,
                                      studentPlan.studentPlanPayments[0]?.providerCancelDate,
                                    )}
                                  </div>
                                ) : (
                                  <div className="planCancel">{t("CANCELLED_PLAN")}</div>
                                )}

                                {studentPlan.studentPlanPayments?.length > 0 && !cancels && (
                                  <SCButtonAddInput
                                    color="#fff"
                                    background="#004fff"
                                    onClick={(e) => tooglePaymentHistory(e, studentPlan, studentPlan.planId, true)}
                                  >
                                    {t("MANAGE")}
                                  </SCButtonAddInput>
                                )}
                              </div>
                              <hr />
                              {arrToSort
                                ?.sort((a, b) => a?.lingoLanguageId - b?.lingoLanguageId)
                                ?.map((studentPlanLanguage, index) => {
                                  return (
                                    <div key={index} className="PlansBox row">
                                      <div className="plans plansLingo">
                                        <div className="payment">
                                          <h2>LINGO</h2>
                                          <h3>
                                            <FlagIcon code={studentPlanLanguage.lingoLanguage.flag} />{" "}
                                            {t(studentPlanLanguage.lingoLanguage.description.toUpperCase())}
                                          </h3>
                                        </div>
                                      </div>
                                      <div className="plans last classes">
                                        <div className="payment">
                                          <h2>{t("MULTYPLE_CLASSES")}</h2>
                                          <h3>{t(studentPlanLanguage.randomFixedTeachers.toUpperCase())}</h3>
                                        </div>
                                      </div>
                                      <div className="plans level">
                                        <div className="payment">
                                          <h2>{t("LEVEL")} </h2>
                                          <h3>{studentPlanLanguage.level}</h3>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                              {studentPlan.edit && (
                                <div className="PlansBox">
                                  <div className="buttons">
                                    <button onClick={(e) => handleSubmit(e, false)}>{t("BTN_CANCEL")}</button>
                                    <button onClick={(e) => handleSubmit(e, true)}>{t("BTN_SAVE")}</button>
                                  </div>
                                </div>
                              )}
                              {studentPlan.studentPlanPayments?.length > 0 && !cancels && (
                                <>
                                  {!hasCancelDate && !cancels && (
                                    <DowngradeUpgrade
                                      plans={plans}
                                      setPlans={setPlans}
                                      changeType={changeType}
                                      studentPlan={studentPlan}
                                      setOpenPlans={setOpenPlans}
                                      setChangeType={setChangeType}
                                      setShowManagePlan={setShowManagePlan}
                                      setSelectedPlanId={setSelectedPlanId}
                                    />
                                  )}
                                </>
                              )}
                            </div>

                            {studentPlan.studentPlanPayments?.length > 0 && (
                              <>
                                {studentPlan.studentPlanPayments[0].newPlan &&
                                  studentPlan.studentPlanPayments[0].providerState !== "Cancelled" && (
                                    <>
                                      {moment().isBefore(studentPlan.studentPlanPayments[0]?.providerNextCycleDate) && (
                                        <div className="box">
                                          <div className="PlansBox">
                                            <div className="plans">
                                              <img src={IconPricing} alt="" width="40" height="40" />
                                              <div className="changePlan">
                                                <h2>{studentPlan.studentPlanPayments[0].newPlan.nameEnglish}</h2>
                                              </div>
                                            </div>

                                            <p style={{ color: "#00D36A", fontWeight: "bold", fontSize: 14 }}>
                                              {t("DATE_CHANGE_PLAN")}{" "}
                                              {moment(studentPlan.studentPlanPayments[0]?.providerNextCycleDate).format(
                                                t("DATE_FORMAT"),
                                              )}
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  )}
                              </>
                            )}
                          </Fragment>
                        );
                      })}
                      {studentPlans?.length === 0 && (
                        <div>
                          <h4
                            style={{
                              fontSize: "24px",
                              fontFamily: "Quicksand",
                              fontWeight: "500",
                              color: "#797881",
                              margin: "20px",
                              textAlign: "center",
                            }}
                          >
                            {t("NO_RESULTS")}
                          </h4>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {showManagePlan && !openPlans && (
                  <Billing>
                    <div className="box">
                      <div className="topBox">
                        <img src={IconPricing} alt="" width="40" height="40" />
                        <h2>{selectedPlanName}</h2>
                      </div>
                      <ol className="tab-list">
                        <div className="tabsContent">
                          <li
                            className={showPaymentHistories ? "tab-list-item tab-list-active" : "tab-list-item"}
                            onClick={() => {
                              setShowPaymentHistories(true);
                              setShowPlanInfo(false);
                            }}
                          >
                            {t("BILLING_HISTORY")}
                          </li>
                          <li
                            className={showPlanInfo ? "tab-list-item tab-list-active" : "tab-list-item"}
                            onClick={() => {
                              setShowPaymentHistories(false);
                              setShowPlanInfo(true);
                            }}
                          >
                            {t("MANAGE")}
                          </li>
                        </div>
                      </ol>
                    </div>

                    {showPaymentHistories && (
                      <Billing>
                        {historyPlan?.length > 0 &&
                          historyPlan[0]?.studentPlanPaymentHistories
                            ?.sort((a, b) => a.id - b.id)
                            .slice(0)
                            .reverse()
                            .map((history, index) => (
                              <div key={index} className="box">
                                <div className="boxInfo">
                                  <div className="infoBilling">
                                    <h2>{t("DATE")}</h2>
                                    <h3>
                                      <span>
                                        {user?.role === "student"
                                          ? moment(history.createdAt).format(t("DATE_FORMAT"))
                                          : moment(history.createdAt).format(t("DATE_FORMAT") + " " + "HH:mm")}
                                      </span>
                                    </h3>
                                  </div>
                                  <div className="infoBilling">
                                    <h2>{t("PROVIDER")}</h2>
                                    <h3>
                                      <span>{historyPlan[0].provider}</span>
                                    </h3>
                                  </div>
                                  <div className="infoBilling word-wrap-break">
                                    <h2>{t("TRANSACTION_ID")}</h2>
                                    <h3>
                                      <span>{history?.invoiceCode ?? historyPlan[0].providerTransactionId}</span>
                                    </h3>
                                  </div>
                                  <div className="infoBilling">
                                    <h2>{t("VALUE")}</h2>
                                    <h3>
                                      <span>
                                        {studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.currency === "BRL"
                                          ? "R$ "
                                          : "U$ "}
                                        {studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.finalPrice}
                                      </span>
                                    </h3>
                                  </div>
                                  <div className="infoBilling">
                                    <h2>{t("STATUS")}</h2>
                                    <h3>
                                      <span>{history.providerState}</span>
                                    </h3>
                                  </div>
                                  {(historyPlan[0]?.provider === "stripe" || historyPlan[0]?.provider === "stripeBR") &&
                                    history?.invoiceLink !== null && (
                                      <div className="infoBilling">
                                        <a
                                          href={history?.invoiceLink}
                                          alt="linkInvoice"
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          <ButtonMB title={t("INVOICE")} />
                                        </a>
                                      </div>
                                    )}
                                </div>
                              </div>
                            ))}
                      </Billing>
                    )}

                    {showPlanInfo && (
                      <Billing>
                        <div className="box">
                          <div className="boxInfo">
                            {studentPlanSelected.studentPlan.studentPlanPayments?.length > 0 && (
                              <div className="pagamento">
                                <div className="plans">
                                  <div className="payment">
                                    <h2>{t("PROVIDER").toUpperCase()}</h2>
                                    <h3>{studentPlanSelected.studentPlan.studentPlanPayments[0].provider}</h3>
                                  </div>
                                </div>
                                <div className="plans">
                                  <div className="payment">
                                    <h2>{t("VALUE").toUpperCase()}</h2>
                                    <h3>
                                      {studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.currency === "BRL"
                                        ? "R$ "
                                        : "U$ "}
                                      {studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.finalPrice}
                                    </h3>
                                  </div>
                                </div>
                                {studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.cardInfo && (
                                  <div className="plans">
                                    <div className="paymentCard">
                                      <h2>{t("PAYMENT_METHOD").toUpperCase()}</h2>
                                      <LineCard
                                        cardInfo={studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.cardInfo}
                                      />
                                    </div>
                                  </div>
                                )}

                                <div className="plans">
                                  {!studentPlanSelected.cancels ? (
                                    <div className="plansButtons">
                                      <div className="payment">
                                        {!studentPlanSelected.hasCancelDate ? (
                                          <SCButtonAddInput
                                            name="remove"
                                            onClick={() => handleCancelPlan(studentPlanSelected.studentPlan)}
                                          >
                                            {t("CANCEL_MY_PLAN")}
                                          </SCButtonAddInput>
                                        ) : (
                                          <>
                                            {studentPlanSelected.studentPlan.studentPlanPayments[0].provider !==
                                              "paypal" && (
                                              <SCButtonAddInput
                                                name="new"
                                                onClick={() => handleRenovatePlan(studentPlanSelected.studentPlan)}
                                              >
                                                {t("PLAN_RENOVATION")}
                                              </SCButtonAddInput>
                                            )}
                                          </>
                                        )}
                                      </div>
                                      <div className="payment">
                                        {!studentPlanSelected.hasCancelDate &&
                                          studentPlanSelected.studentPlan.studentPlanPayments[0].provider !==
                                            "paypal" && (
                                            <SCButtonAddInput name="new" onClick={() => handleChangeCreditCard()}>
                                              {t("CHANGE_CARD_TITLE")}
                                            </SCButtonAddInput>
                                          )}
                                      </div>
                                      <div className="payment">
                                        {textCancelClass(
                                          studentPlanSelected?.studentPlan,
                                          t,
                                          studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.providerCancelDate,
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="planCancel">{t("CANCELLED_PLAN")}</div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </Billing>
                    )}

                    <div className="buttons">
                      <a
                        onClick={() => {
                          setShowManagePlan(false);
                          setShowPaymentHistories(true);
                          setShowPlanInfo(false);
                        }}
                      >
                        <SCButtonAddInput background="#004fff" color="#fff">
                          <i className="fa fa-angle-left" aria-hidden="true"></i>
                          {t("BACK")}
                        </SCButtonAddInput>
                      </a>
                    </div>
                  </Billing>
                )}

                {!openPlans && (
                  <>
                    {studentPlans?.length === 0 && (
                      <div className="divButtonsPlan">
                        <SCButtonAddInput
                          ml="12px"
                          color="#fff"
                          value="Search"
                          background="#004fff"
                          onClick={() => {
                            setChangeType("checkout");
                            loadPlans(cpn);
                          }}
                          style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 5 }}
                        >
                          <FaPlus />
                          {t("PLAN_BUY")}
                        </SCButtonAddInput>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
            {buyPlans?.length > 0 && (
              <>
                {openPlans && !showManagePlan && (
                  <div className="containerCarousel">
                    <Carousel
                      showDots={false} //pontos
                      swipeable={true} //deslizar no celular
                      responsive={responsive} // configuração
                      containerClass="carousel-container"
                    >
                      {plans?.length > 0
                        ? plans
                            ?.filter((item) => item.active && item.activeWeb)
                            ?.map((item, i) => (
                              <CardPlans
                                key={i}
                                cpn={cpn}
                                data={item}
                                changeType={changeType}
                                selectedPlanId={selectedPlanId}
                              />
                            ))
                        : buyPlans
                            ?.filter((item) => item.active && item.activeWeb)
                            ?.map((item, i) => (
                              <CardPlans
                                key={i}
                                cpn={cpn}
                                data={item}
                                changeType={changeType}
                                selectedPlanId={selectedPlanId}
                              />
                            ))}
                    </Carousel>
                  </div>
                )}
                {!openPlans && (
                  <>
                    {(handleRenderPlans() || studentPlans?.length === 0) && (
                      <div className="divButtonsPlan">
                        <SCButtonAddInput
                          ml="12px"
                          color="#fff"
                          value="Search"
                          background="#004fff"
                          onClick={() => loadPlans(cpn)}
                          style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 5 }}
                        >
                          <FaPlus />
                          {t("PLAN_BUY")}
                        </SCButtonAddInput>
                      </div>
                    )}
                  </>
                )}
                {openPlans && (
                  <div className="divButtonsPlan">
                    <SCButtonAddInput
                      ml="12px"
                      background="#004fff"
                      color="#fff"
                      onClick={() => {
                        dispatch(setBuyPlans([]));
                        setOpenPlans(false);
                      }}
                      value="Search"
                      style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 5 }}
                    >
                      <FaArrowLeft />
                      {t("BACK")}
                    </SCButtonAddInput>
                  </div>
                )}
              </>
            )}
          </div>
        </PlansAccountStyles>
      </section>

      <Dialog
        open={openAlert}
        onClose={closeAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="boxModal"
      >
        <DialogTitle id="alert-dialog-title">{alertTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="pass-dialog-description">{alertDescription}</DialogContentText>
        </DialogContent>
        <DialogActions className="boxModal">
          <Button onClick={closeAlert} color="primary" autoFocus>
            {t("CLOSE")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAlertCancel}
        onClose={closeAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="boxModal"
      >
        <DialogTitle id="pass-dialog-title" className="titleCancelClass">
          {t("CANCEL_IMMEDIATE")}
        </DialogTitle>
        {responseError !== "" ? (
          <div>
            <h2 className="titleCancelClass">Cancel plan</h2>
            <img src={cancelImg} alt="cancelImg" />
            <div>
              <div style={{ alignItems: "center", justifyContent: "center", backgroundColor: "rgba(0, 0, 0, 0)" }}>
                <h3>{responseError}</h3>
              </div>
              <br />
              <br />
              <DialogActions className="boxModal">
                <Button onClick={closeAlert} color="primary" autoFocus>
                  {t("CLOSE")}
                </Button>
              </DialogActions>
            </div>
          </div>
        ) : (
          <div>
            {/* <img src={cancelImg} alt="cancelImg" /> */}
            <div style={{ alignItems: "center", justifyContent: "center", backgroundColor: "rgba(0, 0, 0, 0)" }}>
              <h3>{successMsg}</h3>
            </div>
            <br />
            <br />

            {!successMsg === false && (
              <DialogActions className="boxModal">
                <Button onClick={closeAlert} color="primary" autoFocus>
                  {t("CLOSE")}
                </Button>
              </DialogActions>
            )}
          </div>
        )}

        {responseError == "" && successMsg == false ? (
          <div className="cancelModal">
            <h2 className="titleCancelClass">{t("CANCEL_PLAN")}</h2>
            <DialogContent>
              <div className="boxModal">
                <img src={cancelImg} alt="cancelImg" />

                <form className="formulario boxModal">
                  <h3>
                    {t("CANCEL_PLAN_MENSSAGEM")}
                    <br /> {t("CANCEL_PLAN_MENSSAGEM_2")}
                  </h3>
                  <textarea
                    type="text"
                    placeholder={t("TELL_US_CANCEL_MY_PLAN")}
                    name="reasonForcancellation"
                    id="reasonForcancellation"
                    value={reasonForcancellation}
                    onChange={handleChangeModal}
                    required="required"
                    className="input-lingo inputManage"
                    style={{ marginBottom: 0 }}
                  />
                  {!reasonForcancellation && (
                    <span style={{ color: "red", fontSize: "14px" }}>{t("REQUIRED_FIELD")}</span>
                  )}
                  <br />
                </form>
              </div>
            </DialogContent>
            <DialogActions className="boxModal">
              <Button
                onClick={submitCancel}
                color="secondary"
                autoFocus
                disabled={!reasonForcancellation || btnCanceledDisable}
              >
                {t("CANCEL_MY_PLAN")}
              </Button>
              <Button onClick={closeAlert} color="primary" autoFocus>
                {t("OOOPS_CANCEL_MY_PLAN")}
              </Button>
            </DialogActions>
          </div>
        ) : null}
      </Dialog>

      <Dialog
        open={openalertRenovate}
        onClose={closeAlertRenovate}
        className="boxModal"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="pass-dialog-title">{t("PLAN_RENOVATION")}</DialogTitle>

        {responseError === "" && !successMsg && (
          <div style={{ paddingRight: 30, paddingLeft: 30 }}>
            <DialogContent>
              <DialogContentText id="pass-dialog-description" className="boxModal">
                <img src={cancelImg} alt="cancelImg" />

                <form className="formulario boxModal">
                  <h3>{t("PLAN_RENOVATION_MESSAGE")}</h3>
                </form>
              </DialogContentText>
            </DialogContent>
            <DialogActions className="boxModal">
              <Button onClick={submitRenovatePlan} color="secondary" autoFocus>
                {t("PLAN_RENOVATION")}
              </Button>
              <Button onClick={closeAlertRenovate} color="primary" autoFocus>
                {t("NO")}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>

      <Dialog
        open={openChangeCreditCard}
        onClose={closeChangeCreditCard}
        className="boxModal"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="pass-dialog-title">{t("CHANGE_CARD_TITLE")}</DialogTitle>

        <div style={{ paddingRight: 30, paddingLeft: 30 }}>
          <ChangeCardComponent
            studentPlans={studentPlanSelected?.studentPlan}
            t={t}
            successChange={successChange}
            setSuccessChange={setSuccessChange}
          />

          <DialogActions className="boxModal">
            <Button onClick={closeChangeCreditCard} color="primary" autoFocus>
              {!successChange ? t("BACK") : t("OK")}
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
}

export default PlansAccount;
